import React, { FC, useEffect, useState } from 'react'
import { Redirect } from 'react-router-dom'
import { Icon, Table } from 'antd'
import { Page } from '../../components'
import { useAuth } from '../../providers/AuthProvider'
import { serviceProviderService } from '../../services'
import { ResellerLicenseUsage, ServiceProvidersLicenseUsage } from '../../types'
import { ColumnProps } from 'antd/lib/table'

const LicenseUsageReportPage: FC = () => {
	const [isLoading, setIsLoading] = useState<boolean>(false)
	const [report, setReport] = useState<ServiceProvidersLicenseUsage[]>([])
	const { userHasPermission, user } = useAuth()
	const isMondagoAdmin = userHasPermission(['ServiceProvider.All.ReadWrite'])
	const hasServiceProviderWithLimit = user.service_providers.some(sp => sp.hasLicenseLimit)

	useEffect(() => {
		if (isMondagoAdmin || user.service_providers.length > 1 || hasServiceProviderWithLimit) {
			const fetchReport = async (): Promise<void> => {
				setIsLoading(true)
				const { data } = await serviceProviderService.getLicenseUsageReport()
				setReport(data)
				setIsLoading(false)
			}
			fetchReport()
		}
	}, [isMondagoAdmin, user, hasServiceProviderWithLimit])

	if (!isMondagoAdmin && user.service_providers.length === 1 && !hasServiceProviderWithLimit) {
		const serviceProviderPath = `/serviceprovider/${user.service_providers[0].id}/children`
		return <Redirect to={serviceProviderPath} />
	}

	const resellerExpanded = (data: ServiceProvidersLicenseUsage) => {
		const resellerColumns: ColumnProps<ResellerLicenseUsage>[] = [
			{
				title: 'Reseller Name',
				dataIndex: 'name',
				key: 'name'
			},
			{
				title: 'Limit Enabled',
				dataIndex: 'limit_enabled',
				key: 'limit_enabled',
				align: 'center',
				render: (enabled: boolean) => (enabled ? <Icon title='Enabled' type='check' /> : <Icon title='Disabled' type='close' />)
			},
			{
				title: 'Limit',
				dataIndex: 'limit',
				align: 'center',
				key: 'limit'
			},
			{
				title: 'Allocated',
				dataIndex: 'allocated',
				align: 'center',
				key: 'allocated'
			}
		]

		return <Table columns={resellerColumns} pagination={false} dataSource={data.resellers} />
	}

	const columns: ColumnProps<ServiceProvidersLicenseUsage>[] = [
		{
			title: 'Service Provider Name',
			dataIndex: 'name',
			key: 'name'
		},
		{
			title: 'License Type',
			dataIndex: 'license_type',
			key: 'license_type'
		},
		{
			title: 'Total Allocation',
			dataIndex: 'allocated',
			key: 'total'
		}
	]

	return (
		<Page title={'License Allocation Report'}>
			<Table expandedRowRender={resellerExpanded} columns={columns} dataSource={report} loading={isLoading} />
		</Page>
	)
}

export default LicenseUsageReportPage
